// extracted by mini-css-extract-plugin
export default {"baseTabs":"agent-tabs_baseTabs__PPqa5","tabTitle":"agent-tabs_tabTitle__IMqeK","withGradientBg":"agent-tabs_withGradientBg__-jOrN"};